"use strict";

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cameras_1 = __importDefault(require("./cameras"));

var mobiles_1 = __importDefault(require("./mobiles"));

var televisions_1 = __importDefault(require("./televisions"));

var cars_1 = __importDefault(require("./cars"));

var consoles_1 = __importDefault(require("./consoles"));

var notebooks_1 = __importDefault(require("./notebooks"));

var portable_media_players_1 = __importDefault(require("./portable-media-players"));

var deviceParsers = [consoles_1.default, cars_1.default, cameras_1.default, televisions_1.default, portable_media_players_1.default, mobiles_1.default, notebooks_1.default];

var ClientParser = function ClientParser() {
  _classCallCheck(this, ClientParser);

  this.parse = function (userAgent) {
    var _iterator = _createForOfIteratorHelper(deviceParsers),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var Parser = _step.value;
        var parser = new Parser();
        var device = parser.parse(userAgent);

        if (device.type !== "") {
          return device;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return null;
  };
};

exports.default = ClientParser;